// extracted by mini-css-extract-plugin
export var arrows = "_22-5";
export var decrementer = "_22-9";
export var disabled = "_22-3";
export var error = "_22-1";
export var hiddenText = "_22-a";
export var incrementer = "_22-8";
export var input = "_22-7";
export var inputWrapper = "_22-0";
export var leadingIcon = "_22-b";
export var readonly = "_22-2";
export var regular = "_22-6";
export var small = "_22-4";